import * as React from 'react';
import Svg, { G, Path, Rect } from 'react-native-svg';

export default function CheckMark() {
  return (
    <Svg fill="none" height="73" viewBox="0 0 74 73" width="74">
      <G filter="url(#filter0_d_1325_8855)">
        <Rect
          fill="#B8ECE0"
          height="55"
          rx="12"
          shape-rendering="crispEdges"
          width="55"
          transform={[{ translateX: 9.5 }, { translateY: 5 }]}
        />
        <Path
          d="M52.94 18.16C53.3 17.64 53.18 16.93 52.66 16.56C52.14 16.2 51.43 16.32 51.06 16.84L36.98 36.85L31.17 28.97C30.8 28.46 30.08 28.35 29.57 28.72C29.06 29.1 28.95 29.82 29.33 30.32L36.08 39.49C36.29 39.79 36.64 39.96 37 39.96C37 39.96 37.01 39.96 37.01 39.96C37.38 39.96 37.73 39.77 37.94 39.47L48.39 24.62C49.99 26.92 50.85 29.67 50.85 32.5C50.85 36.2 49.41 39.68 46.8 42.3C44.18 44.91 40.7 46.35 37 46.35C33.3 46.35 29.82 44.91 27.2 42.3C24.59 39.68 23.15 36.2 23.15 32.5C23.15 28.8 24.59 25.32 27.2 22.7C29.82 20.09 33.3 18.65 37 18.65C38.8 18.65 40.55 18.98 42.2 19.65C42.78 19.89 43.45 19.61 43.69 19.02C43.92 18.43 43.64 17.77 43.06 17.53C41.13 16.75 39.09 16.35 37 16.35C34.82 16.35 32.71 16.78 30.72 17.62C28.79 18.44 27.07 19.6 25.58 21.08C24.1 22.57 22.94 24.29 22.12 26.21C21.28 28.21 20.85 30.32 20.85 32.5C20.85 34.68 21.28 36.79 22.12 38.78C22.94 40.71 24.1 42.43 25.58 43.92C27.07 45.4 28.79 46.56 30.72 47.38C32.71 48.22 34.82 48.65 37 48.65C39.18 48.65 41.29 48.22 43.29 47.38C45.21 46.56 46.93 45.4 48.42 43.92C49.9 42.43 51.06 40.71 51.88 38.78C52.72 36.79 53.15 34.68 53.15 32.5C53.15 28.92 51.96 25.45 49.78 22.64L52.94 18.16V18.16Z"
          fill="#315B4A"
        />
      </G>
    </Svg>
  );
}
